<script>
  export let people;

  let activeSort;

  function sortByAlpha() {
    people = people.sort(function (a, b) {
      let aLastName = a.name.split(" ").pop();
      let bLastName = b.name.split(" ").pop();
      return aLastName.localeCompare(bLastName);
    });
    activeSort = "alpha";
  }

  function sortByAdded() {
    sortByAlpha()
    people = people.sort(function (a, b) {
      let aAdd = Date.parse(a.added)
      let bAdd = Date.parse(b.added)
      return bAdd - aAdd;
    });
    activeSort = "added";
  }

  function anchor(name) {
    return name.replace(/[^A-Za-z]/g, "-")
  }

  function s3Link(slug,suffix) {
    return `https://static.propublica.org/projects/doge-tracker/${slug}.${suffix}`
  }

  function humanDate(date) {
    const d = new Date(date + "T00:00:00")
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: 'America/New_York'
    };
    return d.toLocaleDateString('en-US', options).replace(/ /, '. ')
  }

  sortByAdded();
</script>

<div id="sorter">
  
  <div id="sorter-btn-grp" class="{activeSort}">
    <span>Sort by</span>
    <div class="btn added" on:click={sortByAdded}>Most recently added</div>
    <div class="btn alpha" on:click={sortByAlpha}>Name</div>
  </div>
</div>

<div id="person-list">
{#each people as person}
  <div class="person" id="{anchor(person.name)}">
    <div class="hed-lockup{person.departed ? ' departed' : ''}">
      <div class="avi {person.img ? '' : 'no-image'}">
        {#if person.img}
          <img src={s3Link(person.img, "png")} />
        {:else}
          <img class="placeholder" src="{s3Link("id_badge_icon","svg")}" alt="placeholder avatar" />
        {/if}
      </div>

      <div class="name-title">
        <div class="name-lockup">
          <h3>{person.name}{#if person.age && person.age !== "Unknown"}<span class="age">, {person.age}</span>{/if}</h3>
          <div class="permalink">
            <a href="#{anchor(person.name)}">
            <img class="placeholder" src="{s3Link("link","svg")}" alt="permalink" />
            </a>
          </div>
        </div>

        {#if person.title !== "Unknown"}
          <h4>{person.title}</h4>
        {/if}

        {#if person.agency_connection && person.agency_connection !== "Unknown"}
          <h4 class='musk-connex-hed'>
            <strong>Connected to:</strong> {person.agency_connection}
          </h4>
        {/if}

        {#if person.musk_link}
          <h4 class='musk-connex-hed'>
            <strong>Musk link:</strong> {person.musk_link}
          </h4>
        {/if}

        {#if person.departed}
          <h4 class='departed-pill'>
            <strong>{person.departed}</strong>
          </h4>
        {/if}
      </div>
    </div>

    <div class="bio-wrapper">
      <p>{@html person.bio} </p>
      <p style="text-align:right;"><em>Added {humanDate(person.added)}</em></p>
    </div>
  </div>
{/each}
</div>